import React from "react";
import "../styles/footer.css";
function Footer() {
  return (
    <div className="footer-container">
      <div className="footer">
        <div
          style={{
            width: "50%",
            marginLeft: "25rem",
          }}
        >
          <h1 className="head">
            Copyright © 2018 All rights reserved. Design: Template Mo
          </h1>
        </div>
      </div>
    </div>
  );
}

export default Footer;
